export const sampleData = {
  // Dashboard Stats
  dashboardStats: {
    totalBookings: 1247,
    totalRevenue: 98750.50,
    activeProviders: 145,
    totalCustomers: 892,
    pendingApprovals: 12,
    activeDisputes: 5,
    monthlyGrowth: 15.3,
    revenueGrowth: 22.7
  },

  // Recent Bookings
  recentBookings: [
    {
      id: 1,
      bookingNumber: "BK-2024-001",
      customerName: "Sarah Johnson",
      providerName: "Emily Davis",
      serviceName: "Nanny Service",
      bookingDate: "2024-01-28",
      startTime: "09:00",
      endTime: "13:00",
      status: "confirmed",
      amount: 120.00,
      paymentStatus: "paid"
    },
    {
      id: 2,
      bookingNumber: "BK-2024-002",
      customerName: "Michael Chen",
      providerName: "Jessica Martinez",
      serviceName: "Postpartum Nurse",
      bookingDate: "2024-01-28",
      startTime: "14:00",
      endTime: "17:00",
      status: "in_progress",
      amount: 150.00,
      paymentStatus: "paid"
    },
    {
      id: 3,
      bookingNumber: "BK-2024-003",
      customerName: "Emma Wilson",
      providerName: "Sophia Anderson",
      serviceName: "Lactation Consultant",
      bookingDate: "2024-01-29",
      startTime: "10:00",
      endTime: "11:00",
      status: "pending",
      amount: 60.00,
      paymentStatus: "pending"
    },
    {
      id: 4,
      bookingNumber: "BK-2024-004",
      customerName: "David Brown",
      providerName: "Olivia Taylor",
      serviceName: "Baby Massage",
      bookingDate: "2024-01-29",
      startTime: "15:30",
      endTime: "16:15",
      status: "completed",
      amount: 45.00,
      paymentStatus: "paid"
    },
    {
      id: 5,
      bookingNumber: "BK-2024-005",
      customerName: "Lisa Anderson",
      providerName: "Emma Thompson",
      serviceName: "Sleep Training",
      bookingDate: "2024-01-30",
      startTime: "11:00",
      endTime: "12:30",
      status: "confirmed",
      amount: 67.50,
      paymentStatus: "paid"
    }
  ],

  // Providers List
  providers: [
    {
      id: 1,
      firstName: "Emily",
      lastName: "Davis",
      email: "emily.davis@example.com",
      phone: "+1-555-0101",
      profileImage: "https://i.pravatar.cc/150?img=1",
      status: "approved",
      approvalStatus: "approved",
      rating: 4.8,
      totalReviews: 156,
      totalBookings: 243,
      yearsExperience: 8,
      hourlyRate: 30.00,
      services: ["Nanny Service", "Baby Massage"],
      joinedDate: "2023-03-15",
      bio: "Experienced childcare professional with 8 years in infant and toddler care.",
      backgroundCheckStatus: "verified",
      totalEarnings: 7290.00
    },
    {
      id: 2,
      firstName: "Jessica",
      lastName: "Martinez",
      email: "jessica.m@example.com",
      phone: "+1-555-0102",
      profileImage: "https://i.pravatar.cc/150?img=5",
      status: "approved",
      approvalStatus: "approved",
      rating: 4.9,
      totalReviews: 203,
      totalBookings: 312,
      yearsExperience: 12,
      hourlyRate: 50.00,
      services: ["Postpartum Nurse", "Lactation Consultant"],
      joinedDate: "2023-01-20",
      bio: "Certified postpartum nurse specializing in newborn care and maternal support.",
      backgroundCheckStatus: "verified",
      totalEarnings: 15600.00
    },
    {
      id: 3,
      firstName: "Sophia",
      lastName: "Anderson",
      email: "sophia.a@example.com",
      phone: "+1-555-0103",
      profileImage: "https://i.pravatar.cc/150?img=9",
      status: "pending",
      approvalStatus: "pending",
      rating: 0,
      totalReviews: 0,
      totalBookings: 0,
      yearsExperience: 5,
      hourlyRate: 40.00,
      services: ["Lactation Consultant"],
      joinedDate: "2024-01-25",
      bio: "IBCLC certified lactation consultant with passion for supporting new mothers.",
      backgroundCheckStatus: "pending",
      totalEarnings: 0
    },
    {
      id: 4,
      firstName: "Olivia",
      lastName: "Taylor",
      email: "olivia.t@example.com",
      phone: "+1-555-0104",
      profileImage: "https://i.pravatar.cc/150?img=10",
      status: "approved",
      approvalStatus: "approved",
      rating: 4.7,
      totalReviews: 89,
      totalBookings: 134,
      yearsExperience: 6,
      hourlyRate: 35.00,
      services: ["Baby Massage", "Sleep Training"],
      joinedDate: "2023-06-10",
      bio: "Certified infant massage therapist and sleep consultant.",
      backgroundCheckStatus: "verified",
      totalEarnings: 4690.00
    },
    {
      id: 5,
      firstName: "Emma",
      lastName: "Thompson",
      email: "emma.t@example.com",
      phone: "+1-555-0105",
      profileImage: "https://i.pravatar.cc/150?img=20",
      status: "approved",
      approvalStatus: "approved",
      rating: 4.6,
      totalReviews: 67,
      totalBookings: 98,
      yearsExperience: 4,
      hourlyRate: 45.00,
      services: ["Sleep Training", "Nanny Service"],
      joinedDate: "2023-08-22",
      bio: "Gentle sleep training specialist with holistic approach.",
      backgroundCheckStatus: "verified",
      totalEarnings: 4410.00
    }
  ],

  // Customers List
  customers: [
    {
      id: 1,
      firstName: "Sarah",
      lastName: "Johnson",
      email: "sarah.j@example.com",
      phone: "+1-555-0201",
      profileImage: "https://i.pravatar.cc/150?img=47",
      loyaltyPoints: 1250,
      loyaltyTier: "gold",
      totalBookings: 23,
      joinedDate: "2023-05-12",
      address: "123 Main St, New York, NY 10001",
      totalSpent: 2760.00
    },
    {
      id: 2,
      firstName: "Michael",
      lastName: "Chen",
      email: "michael.c@example.com",
      phone: "+1-555-0202",
      profileImage: "https://i.pravatar.cc/150?img=12",
      loyaltyPoints: 2100,
      loyaltyTier: "platinum",
      totalBookings: 35,
      joinedDate: "2023-02-08",
      address: "456 Oak Ave, Los Angeles, CA 90001",
      totalSpent: 5250.00
    },
    {
      id: 3,
      firstName: "Emma",
      lastName: "Wilson",
      email: "emma.w@example.com",
      phone: "+1-555-0203",
      profileImage: "https://i.pravatar.cc/150?img=48",
      loyaltyPoints: 450,
      loyaltyTier: "bronze",
      totalBookings: 7,
      joinedDate: "2023-11-20",
      address: "789 Pine Rd, Chicago, IL 60601",
      totalSpent: 840.00
    },
    {
      id: 4,
      firstName: "David",
      lastName: "Brown",
      email: "david.b@example.com",
      phone: "+1-555-0204",
      profileImage: "https://i.pravatar.cc/150?img=13",
      loyaltyPoints: 1580,
      loyaltyTier: "silver",
      totalBookings: 19,
      joinedDate: "2023-07-15",
      address: "321 Elm St, Houston, TX 77001",
      totalSpent: 2280.00
    },
    {
      id: 5,
      firstName: "Lisa",
      lastName: "Anderson",
      email: "lisa.a@example.com",
      phone: "+1-555-0205",
      profileImage: "https://i.pravatar.cc/150?img=49",
      loyaltyPoints: 890,
      loyaltyTier: "bronze",
      totalBookings: 12,
      joinedDate: "2023-09-03",
      address: "654 Maple Dr, Phoenix, AZ 85001",
      totalSpent: 1440.00
    }
  ],

  // Payments
  payments: [
    {
      id: 1,
      bookingNumber: "BK-2024-001",
      customerName: "Sarah Johnson",
      amount: 120.00,
      status: "completed",
      paymentMethod: "stripe",
      stripePaymentIntentId: "pi_1234567890",
      paidAt: "2024-01-27 10:30:00",
      currency: "USD"
    },
    {
      id: 2,
      bookingNumber: "BK-2024-002",
      customerName: "Michael Chen",
      amount: 150.00,
      status: "completed",
      paymentMethod: "stripe",
      stripePaymentIntentId: "pi_0987654321",
      paidAt: "2024-01-27 14:15:00",
      currency: "USD"
    },
    {
      id: 3,
      bookingNumber: "BK-2024-003",
      customerName: "Emma Wilson",
      amount: 60.00,
      status: "pending",
      paymentMethod: "stripe",
      stripePaymentIntentId: "pi_1122334455",
      paidAt: null,
      currency: "USD"
    }
  ],

  // Payouts
  payouts: [
    {
      id: 1,
      providerName: "Emily Davis",
      amount: 2450.00,
      periodStart: "2024-01-01",
      periodEnd: "2024-01-15",
      totalBookings: 28,
      status: "completed",
      processedAt: "2024-01-16 09:00:00",
      stripeTransferId: "tr_1234567890"
    },
    {
      id: 2,
      providerName: "Jessica Martinez",
      amount: 3200.00,
      periodStart: "2024-01-01",
      periodEnd: "2024-01-15",
      totalBookings: 35,
      status: "completed",
      processedAt: "2024-01-16 09:00:00",
      stripeTransferId: "tr_0987654321"
    },
    {
      id: 3,
      providerName: "Olivia Taylor",
      amount: 1890.00,
      periodStart: "2024-01-16",
      periodEnd: "2024-01-31",
      totalBookings: 22,
      status: "pending",
      processedAt: null,
      stripeTransferId: null
    }
  ],

  // Disputes
  disputes: [
    {
      id: 1,
      bookingNumber: "BK-2023-945",
      filedBy: "Sarah Johnson",
      filedAgainst: "Emily Davis",
      reason: "Service Quality Issue",
      description: "Provider arrived 30 minutes late and seemed unprepared.",
      status: "open",
      priority: "high",
      createdAt: "2024-01-26 15:30:00"
    },
    {
      id: 2,
      bookingNumber: "BK-2023-932",
      filedBy: "Michael Chen",
      filedAgainst: "Jessica Martinez",
      reason: "Cancellation Dispute",
      description: "Provider cancelled last minute without proper notice.",
      status: "in_review",
      priority: "medium",
      createdAt: "2024-01-25 09:15:00"
    },
    {
      id: 3,
      bookingNumber: "BK-2023-901",
      filedBy: "Emma Wilson",
      filedAgainst: "Sophia Anderson",
      reason: "Payment Issue",
      description: "Charged for services not rendered.",
      status: "resolved",
      priority: "low",
      resolution: "Full refund issued to customer. Provider warned.",
      resolvedAt: "2024-01-24 14:00:00",
      createdAt: "2024-01-22 11:00:00"
    }
  ],

  // Promotions
  promotions: [
    {
      id: 1,
      code: "WELCOME50",
      name: "Welcome Offer",
      description: "50% off first booking",
      discountType: "percentage",
      discountValue: 50,
      maxDiscountAmount: 50.00,
      minBookingAmount: 30.00,
      maxUses: 500,
      totalUsed: 234,
      validFrom: "2024-01-01",
      validUntil: "2024-03-31",
      isActive: true,
      userType: "customer"
    },
    {
      id: 2,
      code: "NEWYEAR2024",
      name: "New Year Special",
      description: "$20 off on all bookings",
      discountType: "fixed",
      discountValue: 20.00,
      maxDiscountAmount: 20.00,
      minBookingAmount: 50.00,
      maxUses: 1000,
      totalUsed: 567,
      validFrom: "2024-01-01",
      validUntil: "2024-01-31",
      isActive: true,
      userType: "all"
    },
    {
      id: 3,
      code: "MOTHERSDAY",
      name: "Mother's Day Special",
      description: "30% off postpartum services",
      discountType: "percentage",
      discountValue: 30,
      maxDiscountAmount: 75.00,
      minBookingAmount: 100.00,
      maxUses: 200,
      totalUsed: 89,
      validFrom: "2024-05-01",
      validUntil: "2024-05-31",
      isActive: false,
      userType: "customer"
    }
  ],

  // Services
  services: [
    {
      id: 1,
      name: "Nanny Service",
      category: "Childcare",
      slug: "nanny-service",
      description: "Professional childcare at your home",
      basePrice: 30.00,
      durationMinutes: 120,
      isActive: true,
      isPopular: true,
      totalProviders: 45,
      totalBookings: 567
    },
    {
      id: 2,
      name: "Postpartum Nurse",
      category: "Healthcare",
      slug: "postpartum-nurse",
      description: "Specialized care for mother and newborn",
      basePrice: 50.00,
      durationMinutes: 180,
      isActive: true,
      isPopular: true,
      totalProviders: 28,
      totalBookings: 432
    },
    {
      id: 3,
      name: "Lactation Consultant",
      category: "Healthcare",
      slug: "lactation-consultant",
      description: "Breastfeeding support and guidance",
      basePrice: 40.00,
      durationMinutes: 60,
      isActive: true,
      isPopular: true,
      totalProviders: 22,
      totalBookings: 298
    },
    {
      id: 4,
      name: "Baby Massage",
      category: "Wellness",
      slug: "baby-massage",
      description: "Therapeutic massage for infants",
      basePrice: 35.00,
      durationMinutes: 45,
      isActive: true,
      isPopular: false,
      totalProviders: 18,
      totalBookings: 156
    },
    {
      id: 5,
      name: "Sleep Training",
      category: "Consultation",
      slug: "sleep-training",
      description: "Help establish healthy sleep routines",
      basePrice: 45.00,
      durationMinutes: 90,
      isActive: true,
      isPopular: false,
      totalProviders: 15,
      totalBookings: 203
    },
    {
      id: 6,
      name: "Newborn Photography",
      category: "Photography",
      slug: "newborn-photography",
      description: "Professional newborn photo sessions",
      basePrice: 150.00,
      durationMinutes: 120,
      isActive: true,
      isPopular: false,
      totalProviders: 12,
      totalBookings: 87
    }
  ],

  // Analytics Data
  analyticsData: {
    revenueByMonth: [
      { month: "Jan", revenue: 45000, bookings: 234 },
      { month: "Feb", revenue: 52000, bookings: 267 },
      { month: "Mar", revenue: 48000, bookings: 245 },
      { month: "Apr", revenue: 61000, bookings: 312 },
      { month: "May", revenue: 58000, bookings: 289 },
      { month: "Jun", revenue: 67000, bookings: 334 },
      { month: "Jul", revenue: 72000, bookings: 356 },
      { month: "Aug", revenue: 69000, bookings: 341 },
      { month: "Sep", revenue: 74000, bookings: 367 },
      { month: "Oct", revenue: 78000, bookings: 389 },
      { month: "Nov", revenue: 81000, bookings: 402 },
      { month: "Dec", revenue: 85000, bookings: 421 }
    ],
    topServices: [
      { name: "Nanny Service", bookings: 567, revenue: 17010 },
      { name: "Postpartum Nurse", bookings: 432, revenue: 21600 },
      { name: "Lactation Consultant", bookings: 298, revenue: 11920 },
      { name: "Sleep Training", bookings: 203, revenue: 9135 },
      { name: "Baby Massage", bookings: 156, revenue: 5460 }
    ],
    bookingsByStatus: [
      { status: "Completed", count: 856 },
      { status: "Confirmed", count: 123 },
      { status: "In Progress", count: 45 },
      { status: "Pending", count: 89 },
      { status: "Cancelled", count: 134 }
    ]
  }
};

export default sampleData;